'use strict';

var _extend = require('lodash/object/extend');

var _extend2 = _interopRequireDefault(_extend);

var _request2 = require('./_request');

var _request3 = _interopRequireDefault(_request2);

var _model = require('common/models/base/model');

var _model2 = _interopRequireDefault(_model);

var _errors = require('./errors');

var _errors2 = _interopRequireDefault(_errors);

var _base = require('common/object/base');

var _base2 = _interopRequireDefault(_base);

var _messages = require('common/messages');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
* TODO: possibly move this file over to the common directory (CC)
*/

/*

Usage:

var service = new Service();

service.execute({
name: 'getProgress',
apiEndpointAlias: 'signatureRequest'
}).then(function(data) {

}, catchError);

*/

function isValidJson(text) {
    try {
        JSON.parse(text);
        return true;
    } catch (e) {
        return false;
    }
}

function APIService() {

    _base2['default'].apply(this, arguments);

    //  makes the actual call the the API server. This method
    //  is exposed here so that it can be stubbed out. It should not be called directly within the
    //  app (CC)

    if (!this._request) {
        this._request = _request3['default'];
    }
}

_base2['default'].extend(APIService, {

    /**
     */

    notify: function notify(message) {
        if (message.apiEndpointAlias != void 0 && message.type != void 0) {
            return this.execute(message);
        }
    },

    /**
    */

    execute: function execute(request) {

        var type = request.type || request.name;
        var apiEndpointAlias = request.apiEndpointAlias;

        var endpoint = this.endpoints[apiEndpointAlias];

        // look for an endpoint such as { signatureRequest: { getStatus: function() { }}}
        if (!endpoint) {
            throw new Error('apiEndpointAlias "' + apiEndpointAlias + '" does not exist');
        }

        // from the endpoint, pull out the mapping function. e.g: signatureRequest.getStatus
        var mapRequestOptions = endpoint[type];

        if (!mapRequestOptions) {
            throw new Error('action "' + type + '" does not exist on "' + apiEndpointAlias + '" endpoint');
        }

        // get the information that needs to get blasted off to the server
        var requestOptions = mapRequestOptions(request);

        // some cases where requestOps is the actual request
        var response = requestOptions.then ? requestOptions : null;
        if (!response) {

            // add cache buster to every API request.
            // Note that some query params are strings - wanna ignore those (CC)
            if (typeof requestOptions.query !== 'string') {
                requestOptions.query = Object.assign({}, requestOptions.query, {
                    _c: Date.now()
                });
            }

            response = this._request(requestOptions).then(function (resp) {

                // TODO - success is redundant if the server is returning a 200 code. Is it safe to
                // remove the boolean check here? (CC)
                if (typeof resp.success !== 'boolean' || resp.data === void 0 && resp.error === void 0) {
                    console.warn('Server response improperly formatted: ', resp);
                }

                if (resp.success !== false) {
                    return Promise.resolve(resp.data || resp);
                } else {
                    return Promise.reject(resp.error);
                }
            });
        }

        if (requestOptions.transformResponse) {
            response = response.then(requestOptions.transformResponse);
        }

        response['catch'](this._onRequestError.bind(this)).then(this._onRequestComplete.bind(this, request));

        return response;
    },

    /**
    */

    _onRequestComplete: function _onRequestComplete(request, response) {
        var _this = this;

        // slight hack. Need to delay notification until after the requestor
        // recieves response. (CC)
        setTimeout(function () {
            _this.notifier.notify(_messages.ResponseMessage.create(response, request));
        }, 10);
    },

    /**
    */

    _onRequestError: function _onRequestError(error, resp) {

        // Format error
        var ex;
        if (error && error.crossDomain === true) {
            // NOTE: SuperAgent returns a Cross-Domain exception when there's no network
            // TODO: Switch to using error.xhr.statusCode
            ex = {
                'code': _errors2['default'].NETWORK
            };
        } else if (error && error.response && isValidJson(error.response.text)) {
            try {
                ex = JSON.parse(error.response.text);
                ex = ex.error;
            } catch (e) {}
        } else {
            ex = {
                'code': _errors2['default'].UNKNOWN
            };
        }

        // Merge the decoded api error into the generic error
        // so we can access info from the api error in then/catch callbacks
        (0, _extend2['default'])(error, ex);

        // emit an error so that components & other parts of the app can update their state (CC)
        this.notifier.notify(_messages.ErrorMessage.create(error, this));
    }
});

/**
*/

module.exports = APIService;


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/api/index.js
 ** module id = 574
 ** module chunks = 0
 **/